import axios from 'axios'
// Add instance for Lambda instance
// var lambdaAxios = axios.create({
//     baseURL: 'https://lambda1.tonenetworks.com'
// })
export default {
    GETAUTHVIDEOS ({ commit }, videoType) {
        return axios.get(`/playlists/getJWPlaylistByTitle/${videoType[0]}/${videoType[1]}`).then((response) => {
            const { data: { data } } = response
            let videoData
            if (data && data.length > 0) {
                videoData = data
            } else {
                videoData = null
            }
            if (videoType[0] === 'CAREER') {
                commit('setAuthCareerVideo', {videoObject: videoData})
            } else if (videoType[0] === 'MINDBODY') {
                commit('setAuthMindbodyVideo', {videoObject: videoData})
            } else if (videoType[0] === 'INSPIRATION') {
                commit('setAuthInspirationVideo', {videoObject: videoData})
            } else if (videoType[0] === 'WORK') {
                commit('setAuthWorkVideo', {videoObject: videoData})
            } else if (videoType[0] === 'LIFE') {
                commit('setAuthLifeVideo', {videoObject: videoData})
            } else if (videoType[0] === 'MONEY') {
                commit('setAuthMoneyVideo', {videoObject: videoData})
            } else {
            }
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETAUTHRECOMMENDEDVIDEOS ({ commit }, userId) {
        return axios.get(`recommendations/getPlaylistByUserId/${userId}`).then((response) => {
            const { data: { data } } = response
            let failedVideos = data.filter(x => {
                return (!x && !x.image || x.image === null || x.image === '')
            })
            if (failedVideos && failedVideos.length > 0) {
                console.log('failed videos', failedVideos)
            }
            commit('setAuthRecommendedVideos', {videoObject: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETAUTHRECENTLYWATCHEDVIDEOS ({ commit }, userId) {
        return axios.get(`playlists/getRecentVideoByuserId/${userId}/5`).then((response) => {
            const {data: {data}} = response
            let recentVideos = []
            if (data && data.length > 0) {
                // Loop thru and retreive video details for recently watched videos
                data.forEach(function (videoItem) {
                    return axios.get(`/playlists/getJWVideoByCode/${videoItem.videoCode}`).then((response) => {
                        const { data: { data } } = response
                        if (data[0] && data[0].image) {
                            recentVideos.push(data[0])
                        } else {
                            console.log('video issue', videoItem.videoCode)
                        }
                    }, (err) => {
                        console.log('err ', err)
                    })
                })
                commit('setAuthRecentlyWatchedVideos', {videoObject: recentVideos})
            }
        }, (err) => {
            console.log('err ', err)
            commit('setAuthRecentlyWatchedVideos', {videoObject: null})
        })
    },
    GETUSERFAVORITEVIDEOS ({ commit }, userId) {
        return axios.get(`playlists/getUserVideosById/${userId}`).then((response) => {
            const {data: {data}} = response
            let favVideos = []
            if (data && data.length > 0) {
                // Loop thru and retreive video details for recently watched videos
                data.forEach(function (videoItem) {
                    if (videoItem.liked === '1') {
                        return axios.get(`/playlists/getJWVideoByCode/${videoItem.videoCode}`).then((response) => {
                            const { data: { data } } = response
                            favVideos.push(data[0])
                        }, (err) => {
                            console.log('err ', err)
                        })
                    }
                })
            }
            commit('setAuthUserFavVideos', {favVideos: favVideos})
        }, (err) => {
            console.log('err ', err)
            commit('setAuthUserFavVideos', {favVideos: null})
        })
    },
    GETAUTHQUESTIONS ({ commit }) {
        return axios.get('questions').then((response) => {
            const { data: { data } } = response
            commit('setAuthQuestions', {questions: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    SETANSWER ({ commit }, questionReponse) {
        let userId = questionReponse.userId
        return axios.post('/questions/addUpdateUserAnswers', questionReponse).then((response) => {
            return axios.get(`/playlists/reloadPlaylistByUserQuestionAnswers/${userId}`).then((response) => {
                const { data: { data } } = response
                commit('setAuthRecommendedVideos', {videoObject: data.slice(0, 3)})
            }, (err) => {
                console.log('err ', err)
            })
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETAUTHUSERVIDEOS ({ commit }, userId) {
        return axios.get(`playlists/getUserVideosById/${userId}`).then((response) => {
            const { data: { data } } = response
            commit('setAuthUserVideos', {userVideos: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETTONETEASER ({ commit }, userId) {
        return axios.get(`useremails/getUserToneTeaser/${userId}`).then((response) => {
            const { data: { data } } = response
            if (data) {
                commit('setToneTeasers', {obj: data})
            } else {
                commit('setToneTeasers', {obj: null})
            }
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETTONETAKEAWAY ({ commit }, userId) {
        return axios.get(`tonetakeaways/getUserToneTakeaways/${userId}`).then((response) => {
            const { data: { data } } = response
            console.log('data', data)
            if (data) {
                commit('setToneTakeaways', {obj: data})
            } else {
                commit('setToneTakeaways', {obj: null})
            }
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETAUTHQUOTES ({ commit }, corporationId) {
        return axios.get(`/user/getQuotesAtRandom/${corporationId}`).then((response) => {
            const {data: {data}} = response
            commit('setNewQuote', {quoteObj: data.payload})
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETAUTHGREETNGS ({ commit }, corporationId) {
        // timeofday = 'any'
        return axios.get(`/user/getGreetingsAtRandom/any/${corporationId}`).then((response) => {
            const {data: {data}} = response
            commit('setAuthGreeting', {greetingObj: data.payload})
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETAUTHFUNNIES ({ commit }, corporationId) {
        return axios.get(`/user/getFunniesAtRandom/${corporationId}`).then((response) => {
            const {data: {data}} = response
            commit('setAuthFunnies', {funniesObj: data.payload})
        }, (err) => {
            console.log('err ', err)
        })
    }
}




// WEBPACK FOOTER //
// ./src/store/authpage/actions.js